const elevation = {
    xxs: 3,
    xs: 4,
    s: 6,
    m: 8,
    l: 12,
    xl: 16,
    xxl: 24,
}

export default elevation


// WEBPACK FOOTER //
// ./src/theme/elevation.js